import type { ProductAccommodation } from '@/domainLogic/types/typesProduct.ts';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { getSustainabilityCertificateLabel } from '@/app/common/sustainabilityCertificate.ts';

/**
 * Label for the results-card certification line. Empty when the accommodation holds no
 * certificate or the market's toggles are off — like the detail-page certifications, this
 * needs sustainabilityCertifications on top of the market sustainability flag.
 */
export const useSustainabilityCertificateLabel = (accommodation: ProductAccommodation | undefined): string => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();

  const { sustainabilityEnabled, sustainabilityCertificationsEnabled } = localization?.configValuesApp ?? {};
  if (!sustainabilityEnabled || !sustainabilityCertificationsEnabled) return '';

  return getSustainabilityCertificateLabel(accommodation, t);
};
